(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-tracking-events.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-tracking-events.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _React = React,
  useEffect = _React.useEffect;
const analytics = svs.components.analytics;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectCouponEmpty = _svs$components$tipse.selectCouponEmpty,
  selectCouponStatus = _svs$components$tipse.selectCouponStatus;
const COUPON_VALID = svs.components.tipsen.engine.constants.couponStatus.COUPON_VALID;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const useTrackingEvents = couponId => {
  const draw = useCurrentDraw();
  const _useSelector = useSelector(selectEngineDefinition),
    getDisplayNameByDraw = _useSelector.getDisplayNameByDraw;
  const couponIsEmpty = useSelector(state => selectCouponEmpty(state, couponId));
  const productName = getDisplayNameByDraw(draw);
  const couponStatus = useSelector(state => selectCouponStatus(state, couponId));
  useEffect(() => {
    if (!couponIsEmpty) {
      analytics.trackEvent({
        category: 'Wager',
        action: 'Betslip Started',
        opt_label: productName
      });
    }
  }, [productName, couponIsEmpty]);
  useEffect(() => {
    if (couponStatus === COUPON_VALID) {
      analytics.trackEvent({
        category: 'Wager',
        action: 'Betslip Complete',
        opt_label: productName
      });
    }
  }, [productName, couponStatus]);
};
setGlobal('svs.components.tipsen.couponId.useTrackingEvents', useTrackingEvents);

 })(window);